<template>

<app-view-sheet-field :is-sticky="isSticky" :field="field" :filter="filter">

    <span>{{ value }}</span>

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky', 'isCondensed'],

	computed: {

		value: function() {

			var v = this.item.game && this.item.game.version
			if (!v || !v.size) return '-'
			var s = v.size
			var dims = []
			if (s.width || s.length || s.depth) {
				var parts = [s.width, s.length, s.depth].map(function(n) {
					return n ? (n / 10).toFixed(1) : '?'
				})
				dims.push(parts.join(' × ') + ' cm')
			}
			if (s.weight) {
				dims.push((s.weight >= 1000 ? (s.weight / 1000).toFixed(2) + ' kg' : s.weight + ' g'))
			}
			return dims.length ? dims.join(' · ') : '-'

		}

	}

}

</script>
